import { render, staticRenderFns } from "./operDeal.vue?vue&type=template&id=5d0c5e9e&scoped=true"
import script from "./operDeal.vue?vue&type=script&lang=js"
export * from "./operDeal.vue?vue&type=script&lang=js"
import style0 from "./operDeal.vue?vue&type=style&index=0&id=5d0c5e9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0c5e9e",
  null
  
)

export default component.exports